import accountsStore from './AccountsStore';
import commonStore from './CommonStore';
import userStore from './UserStore';
import exportEventsStore from './ExportEventsStore';
import exportPatientsStore from './ExportPatientsStore';
import versioningStore from './VersioningStore';
import pushNotificationsStore from './PushNotificationsStore';

export default {
  commonStore,
  exportEventsStore,
  exportPatientsStore,
  userStore,
  accountsStore,
  versioningStore,
  pushNotificationsStore,
};
